import css from "./Mapa.module.css"

function Mapa(){
    return(
        <div className={`${css.divmapa} d-flex flex-column justify-content-center align-items-center mb-4`}>
            <p className={`${css.onde}`}>Onde nos encontrar</p>
            <div className={"w-100"}>
                <iframe className={"w-100 rounded-4"}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120774.86851996544!2d-48.34609226677917!3d-18.921891178907853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a4450c10bbbaef%3A0xae370c93616d5c9c!2zVWJlcmzDom5kaWEsIE1H!5e0!3m2!1spt-BR!2sbr!4v1769601496548!5m2!1spt-BR!2sbr"
                    width="600" height="450" allowFullScreen="" loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    )
}

export default Mapa;